// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"AwsCertificatesList_contentComponent__3WgjP","tableContainer":"AwsCertificatesList_tableContainer__6fV1L"};